import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LocaleService } from '@any2any/shared';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigService } from '~app/services/config.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TranslateModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly config = inject(ConfigService);
  private readonly locale = inject(LocaleService);

  constructor() {
    this.locale.initialize(document.querySelector('html')!);
  }
}
